import { Lesson } from '@/models/Lesson';
import { AxiosError } from 'axios';

export enum ListItemsTypes {
    ADD_TO_LIST_REQUEST = '@list/ADD_TO_LIST_REQUEST',
    ADD_TO_LIST_SUCCESS = '@list/ADD_TO_LIST_SUCCESS',
    ADD_TO_LIST_FAILURE = '@list/ADD_TO_LIST_FAILURE',
    ADD_TO_LIST_CLEAR = '@list/ADD_TO_LIST_CLEAR',
    DELETE_FROM_LIST_REQUEST = '@list/DELETE_FROM_LIST_REQUEST',
    DELETE_FROM_LIST_SUCCESS = '@list/DELETE_FROM_LIST_SUCCESS',
    DELETE_FROM_LIST_FAILURE = '@list/DELETE_FROM_LIST_FAILURE',
    DELETE_FROM_LIST_CLEAR = '@list/DELETE_FROM_LIST_CLEAR',
    GET_LIST_ITEMS_REQUEST = '@list/GET_LIST_ITEMS_REQUEST',
    GET_LIST_ITEMS_SUCCESS = '@list/GET_LIST_ITEMS_SUCCESS',
    GET_LIST_ITEMS_FAILURE = '@list/GET_LIST_ITEMS_FAILURE',
    LIST_ITEMS_CLEAR = '@list/LIST_ITEMS_CLEAR',
}
export interface ListItemsState {
    listItems?: Lesson[];
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
    success: boolean;
}
